module.exports = __webpack_public_path__ + "media/images/aba-pay-486551208c1c811a73e540786ade0632.png";